import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';

import { getGuestCollectionTempImg } from 'selectors/guestCollection';

import ConfigureAddressCollectionMobileContainer from './ConfigureAddressCollectionMobileContainer';
import type { RootState } from '../../../../../reducers';

export type ConfigureAddressCollectionPhotoUploaderStateProps = {
  hasImg: boolean;
};

const mapStateToProps = (state: RootState): ConfigureAddressCollectionPhotoUploaderStateProps => ({
  hasImg: !_isEmpty(getGuestCollectionTempImg(state)),
});

export default connect(mapStateToProps)(ConfigureAddressCollectionMobileContainer);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionMobileContainer/index.ts